module.exports = __webpack_public_path__ + "media/images/countrysquared/pt-7f67fe2d1c2e8d06cc642b2113a14437.svg";